(function (module) {
  'use strict';
  module
    .service('myService', function () {})
    .controller('AlertController', ['$rootScope', '$scope', '$state', 'socket', 'socketLogin', 'alertService',
      'smsHistory', 'socketEvent',
      function ($rootScope, $scope, $state, socket, socketLogin, alertService, smsHistory, socketEvent) {},
    ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/alertController.js